import { render, staticRenderFns } from "./dispatchOrder.vue?vue&type=template&id=598fe0dd&scoped=true&"
import script from "./dispatchOrder.vue?vue&type=script&lang=js&"
export * from "./dispatchOrder.vue?vue&type=script&lang=js&"
import style0 from "./dispatchOrder.vue?vue&type=style&index=0&id=598fe0dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598fe0dd",
  null
  
)

export default component.exports